/* lv-filtry-szukaj (26.09.2026): wyszukiwarka w filtrach kolekcji MARKA / WSKAZANIA / RODZAJ PRODUKTU (desktop, lewa kolumna).
   Klik w lupe przy nazwie filtra otwiera pole na szerokosc sekcji (zakrywa nazwe), wpisywanie zaweza liste (bez polskich
   znakow i wielkosci liter), podczas szukania widac tez pozycje schowane pod "Pokaz wiecej". Markup: snippets/facets-vertical.liquid.
   Filtry przeladowuja sie AJAX-em, dlatego wszystko na delegacji zdarzen.
   26.09.2026: przy otwartym polu reszta strony jest przyciemniona (jak lupa w naglowku) - nakladka fixed z "dziura"
   na karte filtra (box-shadow), bo pasek filtrow jest sticky i z-index karty nie wyjdzie ponad naglowek.
   Klik poza karta lub Esc zamyka pole. */
(function () {
  function norm(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l').trim(); }
  function filtruj(d, q) {
    var n = norm(q), ile = 0;
    d.classList.toggle('lv-szukaj-trwa', !!n);
    d.querySelectorAll('.facets__list > li').forEach(function (li) {
      var ok = !n || norm(li.textContent).indexOf(n) !== -1;
      li.classList.toggle('lv-szukaj-ukryty', !ok);
      if (ok) ile++;
    });
    var brak = d.querySelector('.lv-filtr-szukaj__brak');
    if (brak) brak.hidden = !n || ile > 0;
  }
  var cien = null, cienD = null, cienX = null;
  function karta(d) { return d.closest('.facets__disclosure-vertical') || d; }
  function ustawCien() {
    if (!cien) return;
    if (!cienD || !cienD.isConnected || !cienD.classList.contains('lv-szukaj-otwarte')) { usunCien(); return; }
    var r = karta(cienD).getBoundingClientRect();
    cien.style.top = r.top + 'px'; cien.style.left = r.left + 'px';
    cien.style.width = r.width + 'px'; cien.style.height = r.height + 'px';
    requestAnimationFrame(ustawCien);
  }
  function pokazCien(d) {
    if (!cien) { cien = document.createElement('div'); cien.className = 'lv-filtr-cien'; document.body.appendChild(cien); }
    /* 27.09.2026: zamiast okraglego X - kursor krzyzyk poza karta filtra (jak przy lupie w naglowku) */
    document.body.classList.add('lv-filtr-szukaj-aktywne');
    karta(d).classList.add('lv-filtr-karta-aktywna');
    cienD = d;
    requestAnimationFrame(function () { cien.classList.add('is-widoczny'); });
    ustawCien();
  }
  function usunCien() {
    if (cien) { cien.remove(); cien = null; }
    document.body.classList.remove('lv-filtr-szukaj-aktywne');
    document.querySelectorAll('.lv-filtr-karta-aktywna').forEach(function (k) { k.classList.remove('lv-filtr-karta-aktywna'); });
    cienD = null;
  }
  function otworz(d) {
    var box = d.querySelector('.lv-filtr-szukaj');
    if (!box) return;
    d.open = true;
    var sm = d.querySelector('summary');
    box.style.top = sm.offsetTop + 'px'; box.style.left = sm.offsetLeft + 'px';
    box.style.width = sm.offsetWidth + 'px'; box.style.height = Math.max(sm.offsetHeight, 38) + 'px';
    box.hidden = false;
    document.querySelectorAll('details.lv-szukaj-otwarte').forEach(function (x) { if (x !== d) zamknij(x); });
    d.classList.add('lv-szukaj-otwarte');
    pokazCien(d);
    var inp = box.querySelector('input');
    setTimeout(function () { inp.focus(); }, 0);
  }
  function zamknij(d) {
    var box = d.querySelector('.lv-filtr-szukaj');
    if (!box) return;
    box.hidden = true;
    d.classList.remove('lv-szukaj-otwarte');
    box.querySelector('input').value = '';
    filtruj(d, '');
    if (cienD === d) usunCien();
  }
  document.addEventListener('click', function (e) {
    var ik = e.target.closest('[data-lv-filtr-szukaj]');
    if (ik) { e.preventDefault(); e.stopPropagation(); otworz(ik.closest('details')); return; }
    var z = e.target.closest('.lv-filtr-szukaj__zamknij');
    if (z) { e.preventDefault(); zamknij(z.closest('details')); return; }
    /* klik w przyciemniona czesc strony zamyka pole i nie klika w to, co pod spodem */
    if (cienD && !karta(cienD).contains(e.target)) { e.preventDefault(); e.stopPropagation(); zamknij(cienD); }
  }, true);
  document.addEventListener('keydown', function (e) {
    var ik = e.target.closest && e.target.closest('[data-lv-filtr-szukaj]');
    if (ik && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); e.stopPropagation(); otworz(ik.closest('details')); return; }
    var inp = e.target.closest && e.target.closest('.lv-filtr-szukaj__pole');
    if (inp && e.key === 'Escape') { zamknij(inp.closest('details')); }
    if (inp && e.key === 'Enter') { e.preventDefault(); }
  }, true);
  /* capture + stopPropagation: formularz filtrow motywu przeladowuje sekcje na kazde 'input'/'change' */
  document.addEventListener('input', function (e) {
    var inp = e.target.closest && e.target.closest('.lv-filtr-szukaj__pole');
    if (!inp) return;
    e.stopPropagation();
    filtruj(inp.closest('details'), inp.value);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.lv-filtr-szukaj__pole')) { e.stopPropagation(); return; }
    /* wybrany filtr z wynikow wyszukiwania: zamknij pole i zdejmij przyciemnienie, zeby bylo widac produkty */
    var d = e.target.closest && e.target.closest('details.lv-szukaj-otwarte');
    if (d) setTimeout(function () { zamknij(d); }, 0);
  }, true);
})();
